module.exports = __webpack_public_path__ + "static/media/icons_grey_underline.94ade4a6.svg";